import { render, staticRenderFns } from "./BidirectionalStepper.vue?vue&type=template&id=a52d7b66&scoped=true&"
import script from "./BidirectionalStepper.vue?vue&type=script&lang=js&"
export * from "./BidirectionalStepper.vue?vue&type=script&lang=js&"
import style0 from "./BidirectionalStepper.vue?vue&type=style&index=0&id=a52d7b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52d7b66",
  null
  
)

component.options.__file = "BidirectionalStepper.vue"
export default component.exports